import { resolveWebsiteErrorRoute } from "@/utils/resolveWebsiteErrorRoute"

export const useWebsiteErrorRedirect = () => {
  const router = useRouter()
  const route = useRoute()
  const { websiteErrorStatus } = storeToRefs(useWebsiteInfoStore())

  watch(
    () => websiteErrorStatus.value,
    status => {
      if (status === null) return
      const target = resolveWebsiteErrorRoute(status, route.name)
      if (target !== undefined) router.push(target)
    }
  )
}
export default useWebsiteErrorRedirect
